import React from "react";
import PropTypes from "prop-types";
import Select from "../../../../../../components/Select";
import { customStyles } from "../../helpers";

const ErrorWarningText = ({
  userEmail,
  errors,
  annotationTranscript,
  ensemblTranscripts,
  loading,
  transcriptsOptions,
  getNewTranscriptAnnotation,
}) => {
  const pattern = new RegExp("@saphetor.com");
  const isSaphetorUser = pattern.test(userEmail);

  const errorsArray = [];
  if (isSaphetorUser) {
    errors.forEach((item, i) => {
      const key = `${i}${Date.now()}`;
      errorsArray.push(
        <div key={key}>
          {item.classifier ? <b>{item.classifier}: </b> : ""}
          {item.exception}
        </div>
      );
    });
  }

  const regex = new RegExp(
    /^Requested transcript '[a-zA-Z0-9_.]*' not found(.*)$/
  );
  let foundRegex = false;
  let foundTranscript = false;
  let index;
  let transcript;
  let text;

  for (let i = 0; i < errors.length; i++) {
    if (errors[i].exception.match(regex)) {
      foundRegex = true;
      index = i;
      break;
    }
  }

  if (typeof index !== "undefined") {
    // eslint-disable-next-line
      transcript = errors[index].exception.split(" ")[2];
    foundTranscript = ensemblTranscripts.filter((item) => {
      if (
        item.name === transcript &&
        item.ensembl_support_level !== null &&
        item.ensembl_support_level !== 1
      ) {
        return true;
      }
      return false;
    });
  }

  const classifiers = errors.map((e) => e.classifier);
  let classifierFound = false;

  for (let i = 0; i < classifiers.length; i++) {
    if (classifiers[i]) {
      classifierFound = true;
      break;
    }
  }

  if (foundRegex && foundTranscript) {
    text = `Transcript ${transcript.replace(
      /'/g,
      ""
    )} is non-coding or has an unreliable support-level in Ensembl.`;
  } else if (classifierFound) {
    text = `There has been an internal error processing the Germline Variant Classification for this variant in rule${
      classifiers.length > 1 ? "s: " : ": "
    } ${classifiers.join()}`;
  } else {
    text = ` There has been an internal error processing the Germline Variant Classification for this variant.`;
  }

  return (
    <div className="varsome-text-center" style={{ color: "red" }}>
      {errorsArray}
      <br />
      <i className="fa fa-exclamation-circle" />
      {text}
      {!__IS_COMPONENTS_PORTAL__ && (
        <div>
          <div className="varsome-horiz-list-value varsome-acmg-verdict">
            {loading && <i className="fa fa-circle-o-notch fa-spin" />}
          </div>
          <div className="tw-mt-4 tw-mb-8">
            <Select
              isSearchable={false}
              value={
                transcriptsOptions
                  ? transcriptsOptions.filter(
                      (option) => option.value === annotationTranscript
                    )
                  : ""
              }
              options={transcriptsOptions}
              onChange={(e) => getNewTranscriptAnnotation(e)}
              styles={customStyles}
              placeholder="Select a transcript to annotate"
            />
          </div>
        </div>
      )}
    </div>
  );
};

ErrorWarningText.propTypes = {
  userEmail: PropTypes.string,
  errors: PropTypes.arrayOf(PropTypes.shape({ exception: PropTypes.string })),
  annotationTranscript: PropTypes.string,
  ensemblTranscripts: PropTypes.arrayOf(PropTypes.shape({})),
  loading: PropTypes.bool.isRequired,
  transcriptsOptions: PropTypes.arrayOf(PropTypes.shape({})),
  getNewTranscriptAnnotation: PropTypes.func.isRequired,
};

ErrorWarningText.defaultProps = {
  errors: [],
  annotationTranscript: "",
  userEmail: "",
  transcriptsOptions: [],
  ensemblTranscripts: [],
};

export default ErrorWarningText;
